import Base, { ModalProps } from '../Base';

export const UIModal = (props: ModalProps) => {
  return <Base {...props}>{props.children}</Base>;
};
